var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-footer" },
    [
      _c(
        "div",
        { staticClass: "left" },
        [
          _c("div", { staticClass: "record-count" }, [
            _vm._v(
              _vm._s(_vm.$t("tables.recordCount")) +
                ": " +
                _vm._s(_vm.recordCount)
            ),
          ]),
          _vm._v(" "),
          false
            ? _c(
                "SupsisButton",
                {
                  staticClass: "increase-limit-btn",
                  attrs: { disabled: true },
                  on: { click: _vm.increaseLimit },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("tables.increaseLimit")) + "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              staticClass: "new-record-btn",
              on: {
                click: function ($event) {
                  return _vm.$feature.beforeCreateTableRecord(
                    _vm.createNewRecord,
                    _vm.recordCount
                  )
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("add_box")]),
              _vm._v(" " + _vm._s(_vm.$t("tables.newRecord")) + "\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              staticClass: "import-btn",
              on: {
                click: function ($event) {
                  return _vm.$feature.beforeCreateTableRecord(
                    _vm.importRecords,
                    _vm.recordCount
                  )
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("cloud_upload"),
              ]),
              _vm._v(" " + _vm._s(_vm.$t("tables.imports")) + "\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            { staticClass: "export-btn", on: { click: _vm.exportRecords } },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("cloud_download"),
              ]),
              _vm._v(" " + _vm._s(_vm.$t("tables.exports")) + "\n        "),
            ]
          ),
          _vm._v(" "),
          false
            ? _c(
                "SupsisButton",
                {
                  staticClass: "download-btn",
                  attrs: { disabled: true },
                  on: { click: _vm.downloadRecords },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("get_app"),
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("tables.download")) + "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right" },
        [
          _vm.recordCount > _vm.cursor.perPage
            ? _c("a-pagination", {
                attrs: {
                  current: _vm.cursor.page,
                  total: _vm.recordCount,
                  pageSize: _vm.cursor.perPage,
                  "show-size-changer": "",
                  "show-quick-jumper": "",
                  pageSizeOptions: ["100", "250", "500", "750", "1000"],
                  size: "small",
                },
                on: {
                  change: _vm.onPageChange,
                  showSizeChange: _vm.onShowSizeChange,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-popover",
            { attrs: { trigger: "click", placement: "topRight" } },
            [
              _c("template", { slot: "content" }, [
                _c(
                  "div",
                  {
                    staticClass: "automation-popover custom-automation-popover",
                  },
                  [
                    _c("div", { staticClass: "group" }, [
                      _c("div", { staticClass: "group-title" }, [
                        _vm._v(_vm._s(_vm.$t("ticimax.createAutomation"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "group-item event",
                          on: {
                            click: function ($event) {
                              return _vm.showCreateAutomationModal(
                                "table.record_created"
                              )
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("tables.recordCreated")) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "group-item event",
                          on: {
                            click: function ($event) {
                              return _vm.showCreateAutomationModal(
                                "table.record_updated"
                              )
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("update"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("tables.recordUpdated")) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "group-item event",
                          on: {
                            click: function ($event) {
                              return _vm.showCreateAutomationModal(
                                "table.record_deleted"
                              )
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("delete"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("tables.recordDeleted")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "group" },
                      [
                        _c("div", { staticClass: "group-title" }, [
                          _vm._v(_vm._s(_vm.$t("automation.automations"))),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.tableAutomations, function (automation) {
                          return _c(
                            "div",
                            {
                              key: automation._id,
                              staticClass: "group-item automation",
                              on: {
                                click: function ($event) {
                                  return _vm.goToAutomation(automation._id)
                                },
                              },
                            },
                            [
                              _c("atomic-power", {
                                tag: "component",
                                staticClass: "myIcon",
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(automation.name) +
                                  "\n                        "
                              ),
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        !_vm.tableAutomations.length
                          ? _c("div", { staticClass: "no-automation" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("info"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("tables.noAutomationDefined")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "SupsisButton",
                { staticClass: "automate-btn", attrs: { type: "primary" } },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("settings_applications"),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("tables.automateYourData")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: _vm.$t("ticimax.createAutomation") },
          on: { ok: _vm.createAutomation },
          model: {
            value: _vm.createAutomationModalVisible,
            callback: function ($$v) {
              _vm.createAutomationModalVisible = $$v
            },
            expression: "createAutomationModalVisible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "automation-name-input" },
            [
              _c(
                "div",
                { staticClass: "description" },
                [
                  _vm.selectedAutomationEvent === "table.record_created"
                    ? [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("tables.nameTheAutomationAdd")) +
                            "\n                "
                        ),
                      ]
                    : _vm.selectedAutomationEvent === "table.record_updated"
                    ? [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("tables.nameTheAutomationUpdate")) +
                            "\n                "
                        ),
                      ]
                    : _vm.selectedAutomationEvent === "table.record_deleted"
                    ? [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("tables.nameTheAutomationDelete")) +
                            "\n                "
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("a-input", {
                attrs: { placeholder: _vm.$t("automation.automationName") },
                model: {
                  value: _vm.automationName,
                  callback: function ($$v) {
                    _vm.automationName = $$v
                  },
                  expression: "automationName",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }